import list from '../AutoReplySetUp/AutoReplySetUp'
export default list
